import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { IPopularRoutesAvia } from 'shared/api/avia/main-page'
import { priceShow } from 'shared/lib//priceShow'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { ImageLazy } from 'shared/ui/image-lazy'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  data: IPopularRoutesAvia
  onClick?: () => void
}

export const CardPopular: FC<Props> = ({ data, onClick }) => {
  const { city_logo, arr, dep, start_price } = data
  const { t } = useTranslation()
  return (
    <Paper
      padding={[8]}
      radius={16}
    >
      <div
        className={s.container}
        onClick={onClick}
      >
        {city_logo ? (
          <div className={s.left}>
            <ImageLazy
              src={city_logo}
              alt={`${dep.city.title}-${arr.city.title}`}
            />
          </div>
        ) : null}

        <div className={s.right}>
          <p>
            {dep.city.title} - {arr.city.title}
          </p>
          <span>
            {t('from_price', { price: priceShow(String(start_price)) })}
          </span>

          <AppIcon
            id={AllIcons.ARROW_RIGHT}
            className={s.icon}
          />
        </div>
      </div>
    </Paper>
  )
}
